import { FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';
import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';
import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { BreachPathDetailsMetadataSideMenuDataType } from '../types';
import {
  resourceNameRenderer,
} from '../utils/customDataRenderer';
import { BreachPathEvents } from '../../common/types';

/**
 * @summary Breach Path details metadata side menu web component
 * @tag breach-path-details-metadata-side-menu
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('breach-path-details-metadata-side-menu')
export class BreachPathDetailsMetadataSideMenuWebComponment extends LitElement {
  @property({ type: Object, attribute: false })
  data: BreachPathDetailsMetadataSideMenuDataType = {} as BreachPathDetailsMetadataSideMenuDataType;

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    return html`
      <div class="header mt-6 mb-3">
        ${this.renderHeaderSection()}
      </div>
      <div class="content">
        ${this.renderMetadataSection()}
      </div>
    `;
  }

  private renderHeaderSection(): TemplateResult {
    return html`
      <div
        class="back-button"
        @click="${this.handleMetadataBackButtonClick}"
      >
        <gz-icon
          name='ds-icon-arrow_left_collapse'
          size="24"
          color="secondary"
        ></gz-icon>
        <gz-button
          type="quiet"
          color="secondary"
          buttonHeight="small"
          id="back-button-text"
        >
          ${translateFn('Back')}
        </gz-button>
      </div>
      <gz-title fontSize="${FontSizes.HEADING_5}" class="mt-3">
        ${resourceNameRenderer(this.data)}
      </gz-title>
    `;
  }

  private renderMetadataSection(): TemplateResult {
    let parsedMetadata = {};
    let prettyMetadata = '';
    try {
      parsedMetadata = JSON.parse(this.data.metadata);
      prettyMetadata = JSON.stringify(parsedMetadata, null, 4);
    } catch {}

    return html`
      <div class="section pb-1" data-section="metadata">
        <gz-text
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.MEDIUM}"
          class="section-title text-uppercase mb-1"
        >
          ${translateFn('Metadata')}
        </gz-text>
        <div class="json-viewer-container">
          <gz-copy-to-clipboard
            class="copy-icon"
            confirmationMessage="${translateFn('Copied')}"
            tooltipText="${translateFn('Copy to clipboard')}"
            clipboardMessage="${prettyMetadata}"
            multiLine
          ></gz-copy-to-clipboard>
          <gz-json-viewer .jsonData=${parsedMetadata} lineSeparation></gz-json-viewer>
        </div>
      </div>
    `;
  }

  private handleMetadataBackButtonClick = () => {
    this.dispatchEvent(new CustomEvent(BreachPathEvents.GO_BACK_METADATA_RESOURCES_SIDEMENU, {
      detail: {
        data: this.data,
      },
      bubbles: true,
      cancelable: true,
      composed: true,
    }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'breach-path-details-metadata-side-menu': BreachPathDetailsMetadataSideMenuWebComponment;
  }
}
